import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class OneSignalService {
  constructor() {}

  // OneSignal 로드되는 것을 기다리기 위해 Promise를 반환하는 함수
  async onLoad(): Promise<any> {
    return new Promise((resolve) => {
      (window as any).OneSignal.push(function () {
        resolve((window as any).OneSignal);
      });
    });
  }

  // 웹 푸시 알림 서비스를 초기화
  onInit(): void {
    this.onLoad().then((OneSignal) => {
      OneSignal.init({
        appId: 'f4ba7e72-8fa0-4b43-b1f8-ed060ee6c7a5',
      });
    });
  }

  //사용자의 고유한 ID를 얻어오는 함수
  getId() {
    return this.onLoad().then((OneSignal) => {
      OneSignal.getUserId((userId) => userId);
    });
  }
}
